/**
 * Modern Vanilla JS - Product Page Enhancements
 */
(function () {
  "use strict";

  // State management
  let currentQ = 1;
  let origOneTimeP = 0;
  let origRecurringP = 0;

  /**
   * Helper function to query single element
   */
  const qs = (selector) => document.querySelector(selector);

  /**
   * Helper function to query all elements
   */
  const qsa = (selector) => document.querySelectorAll(selector);

  /**
   * Initialize offer newline visibility
   */
  function initOfferNewline() {
    const offerNewlines = qsa(".offer_newline");
    offerNewlines.forEach((el) => (el.style.display = "none"));
  }

  /**
   * Handle radio option changes
   */
  function initRadioOptions() {
    const radioOptions = qsa(".radio_option");
    radioOptions.forEach((radio) => {
      radio.addEventListener("click", () => {
        const autoDeliverInput = qs('input[value="autodeliver"]');
        const offerNewlines = qsa(".offer_newline");
        const display = autoDeliverInput?.checked ? "block" : "none";
        offerNewlines.forEach((el) => (el.style.display = display));
      });
    });
  }

  /**
   * Update quick shop button text
   */
  function updateQuickShopText() {
    const quickShopBtn = qs(".quick_shop.action_button");
    if (quickShopBtn) {
      quickShopBtn.textContent = "SHOP NOW";
    }
  }

  /**
   * Add quantity controls
   */
  function addQuantityControls() {
    const quantityInput = qs(".left > input.quantity");
    if (!quantityInput) return;

    // Create minus button
    const minusBtn = document.createElement("span");
    minusBtn.className = "cq minus";
    minusBtn.innerHTML = "&ndash;";
    quantityInput.parentNode.insertBefore(minusBtn, quantityInput);

    // Create plus button
    const plusBtn = document.createElement("span");
    plusBtn.className = "cq plus";
    plusBtn.innerHTML = "&plus;";
    quantityInput.parentNode.insertBefore(plusBtn, quantityInput.nextSibling);

    // Change input type to text
    quantityInput.type = "text";

    // Initialize current quantity
    currentQ = parseInt(quantityInput.value) || 1;
  }

  /**
   * Initialize original prices
   * Listens for ReCharge widget loaded event
   */
  function initPrices() {
    const oneTimeEl = qs("#rc_price_onetime");
    const recurringEl = qs("#rc_price_autodeliver");

    if (oneTimeEl?.textContent) {
      origOneTimeP = parseFloat(oneTimeEl.textContent.substring(1)) || 0;
    }

    if (recurringEl?.textContent) {
      origRecurringP = parseFloat(recurringEl.textContent.substring(1)) || 0;
    }
  }

  /**
   * Update price display
   */
  function updatePrice() {
    const quantityInput = qs("input.quantity");
    if (!quantityInput) return;

    currentQ = parseInt(quantityInput.value) || 1;
    const newRegPriceNow = origOneTimeP * currentQ;
    const newSubPriceNow = origRecurringP * currentQ;
    const autoDeliverInput = qs('input[value="autodeliver"]');
    const theCurrentPrice = autoDeliverInput?.checked
      ? newSubPriceNow
      : newRegPriceNow;

    setTimeout(() => {
      const saleElements = qsa(".sale");
      saleElements.forEach((el) => {
        el.textContent = `$${theCurrentPrice.toFixed(2)}`;
        el.setAttribute("content", theCurrentPrice.toFixed(2));
      });
    }, 50);
  }

  /**
   * Handle plus button click
   */
  function handlePlusClick() {
    const quantityInput = qs("input.quantity");
    if (!quantityInput) return;

    currentQ++;
    quantityInput.value = currentQ;
    updatePrice();
  }

  /**
   * Handle minus button click
   */
  function handleMinusClick() {
    const quantityInput = qs("input.quantity");
    if (!quantityInput || currentQ <= 1) return;

    currentQ--;
    quantityInput.value = currentQ;
    updatePrice();
  }

  /**
   * Initialize quantity button handlers
   */
  function initQuantityButtons() {
    document.addEventListener("click", (e) => {
      if (e.target.matches("span.plus")) {
        handlePlusClick();
      } else if (e.target.matches("span.minus")) {
        handleMinusClick();
      }
    });
  }

  /**
   * Handle keyboard input validation for quantity
   */
  function initQuantityKeydown() {
    const leftContainer = qs(".left");
    if (!leftContainer) return;

    leftContainer.addEventListener("keydown", (e) => {
      if (!e.target.matches(".quantity")) return;

      const allowedKeys = [46, 8, 9, 27, 13, 110, 190]; // Delete, Backspace, Tab, Esc, Enter, Decimal
      const isAllowed =
        allowedKeys.includes(e.keyCode) ||
        (/65|67|86|88/.test(e.keyCode) && (e.ctrlKey || e.metaKey)) || // Ctrl/Cmd+A/C/V/X
        (e.keyCode >= 35 && e.keyCode <= 40); // Home, End, Arrow keys

      if (!isAllowed) {
        const isNumberKey =
          (e.keyCode >= 48 && e.keyCode <= 57) || // Main keyboard numbers
          (e.keyCode >= 96 && e.keyCode <= 105); // Numpad numbers

        if (!isNumberKey || e.shiftKey) {
          e.preventDefault();
        }
      }
    });
  }

  /**
   * Handle quantity input changes
   */
  function initQuantityKeyup() {
    const quantityInputs = qsa(".left > input.quantity");
    quantityInputs.forEach((input) => {
      input.addEventListener("keyup", () => {
        if (input.value !== "") {
          updatePrice();
        }
      });
    });
  }

  /**
   * Initialize mobile mood navigation
   */
  function initMobileMoodNav() {
    if (window.innerWidth < 481) {
      const header = qs("#shopify-section-header");
      if (header) {
        const mobileMoodNav = document.createElement("div");
        mobileMoodNav.className = "mobilemoodnav";
        mobileMoodNav.textContent = "All";
        header.insertAdjacentElement("afterend", mobileMoodNav);

        mobileMoodNav.addEventListener("click", () => {
          const customCollection = qs(".container.customcollection");
          if (customCollection) {
            customCollection.style.display =
              customCollection.style.display === "none" ? "block" : "none";
          }
        });
      }
    }
  }

  /**
   * Set active collection based on URL
   */
  function setActiveCollection() {
    const collections = {
      "collections/all": "all",
      "collections/womens-health": "womens-health",
      "collections/mens-health": "mens-health",
      "collections/immunity": "immunity",
      "collections/blood-sugar": "blood-sugar",
      "collections/digestion": "digestion",
      "collections/keto": "keto",
      "collections/joint-health": "joint-health",
      "collections/kidney-health": "kidney-health",
    };

    const url = window.location.href;

    for (const [path, className] of Object.entries(collections)) {
      if (url.includes(path)) {
        const element = qs(`.customcollection .${className}`);
        if (element) {
          const activeClass =
            className === "mens-health" ? "superactive" : "active";
          element.classList.add(activeClass);
        }
        break;
      }
    }
  }

  /**
   * Initialize video duration display
   */
  function initVideoDuration() {
    const youtubeContainer = qs(".youtube");
    if (!youtubeContainer) return;

    const iframe = youtubeContainer.querySelector("iframe");
    const videoTime = iframe?.dataset.time;

    if (videoTime) {
      const lastThumb = qs(".product ol.flex-control-thumbs li:last-child");
      if (lastThumb) {
        lastThumb.classList.add("vidon");
        const durationSpan = document.createElement("span");
        durationSpan.className = "duration";
        durationSpan.textContent = videoTime;
        lastThumb.appendChild(durationSpan);
      }
    }
  }

  /**
   * Initialize all features
   */
  function init() {
    initOfferNewline();
    initRadioOptions();
    updateQuickShopText();
    addQuantityControls();
    initQuantityButtons();
    initQuantityKeydown();
    initQuantityKeyup();
    initMobileMoodNav();
    setActiveCollection();
    initVideoDuration();
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("ReChargeWidget-loaded", initPrices);
})();
